import { Button, ButtonProps, ConfigProvider, ConfigProviderProps } from 'antd';

type Props = ButtonProps & {
  colorPrimary?: string 
  colorLink?: string
}
const ThemableButton = (props: Props) => {
  const customProps = [
    'colorPrimary',
    'colorLink'
  ]
  const otherProps = Object.fromEntries(Object.entries(props).filter(([k]) => !customProps.includes(k)))

  const theme: ConfigProviderProps['theme'] = {}
  if (props.colorPrimary) {
    theme.token = {
      colorPrimary: props.colorPrimary
    }
  }
  if (props.colorLink) {
    theme.components = {
      Button: {
        colorLink: props.colorLink
      }
    }
  }

  return <ConfigProvider theme={theme}>
    <Button {...otherProps} />
  </ConfigProvider>
}
export default ThemableButton
